import { render, staticRenderFns } from "./personal-details-step.vue?vue&type=template&id=5eb12325"
import script from "./personal-details-step.vue?vue&type=script&lang=ts"
export * from "./personal-details-step.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports